// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type CheckPromoEligibilityQueryVariables = Types.Exact<{
  input: Types.PromoCodeEligibilityRequestInput;
}>;


export type CheckPromoEligibilityQuery = { __typename?: 'Query', checkPromoEligibility?: { __typename?: 'PromoEligibilityResponse', skus: Array<{ __typename?: 'PromoEligibilityEntry', sku: string, data?: { __typename?: 'PromoEligibility', uuid: string, hidePromoDetailsForAnonUser?: boolean | null, terms: { __typename?: 'PromoEligibilityTerms', promoType: string, promoCode: string, discount?: number | null, qualifierType?: string | null, currency?: string | null, validFrom?: string | null, validTo?: string | null, tiers?: Array<{ __typename?: 'PromoTier', tier: number, qualifyingAmount: number, discount: number }> | null } } | null }> } | null };


export const CheckPromoEligibilityDocument = gql`
    query CheckPromoEligibility($input: PromoCodeEligibilityRequestInput!) {
  checkPromoEligibility(input: $input) {
    skus {
      sku
      data {
        uuid
        terms {
          promoType
          promoCode
          discount
          qualifierType
          currency
          tiers {
            tier
            qualifyingAmount
            discount
          }
          validFrom
          validTo
        }
        hidePromoDetailsForAnonUser
      }
    }
  }
}
    `;
export type CheckPromoEligibilityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CheckPromoEligibilityQuery, CheckPromoEligibilityQueryVariables>, 'query'> & ({ variables: CheckPromoEligibilityQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CheckPromoEligibilityComponent = (props: CheckPromoEligibilityComponentProps) => (
      <ApolloReactComponents.Query<CheckPromoEligibilityQuery, CheckPromoEligibilityQueryVariables> query={CheckPromoEligibilityDocument} {...props} />
    );
    

/**
 * __useCheckPromoEligibilityQuery__
 *
 * To run a query within a React component, call `useCheckPromoEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPromoEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPromoEligibilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckPromoEligibilityQuery(baseOptions: Apollo.QueryHookOptions<CheckPromoEligibilityQuery, CheckPromoEligibilityQueryVariables> & ({ variables: CheckPromoEligibilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckPromoEligibilityQuery, CheckPromoEligibilityQueryVariables>(CheckPromoEligibilityDocument, options);
      }
export function useCheckPromoEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckPromoEligibilityQuery, CheckPromoEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckPromoEligibilityQuery, CheckPromoEligibilityQueryVariables>(CheckPromoEligibilityDocument, options);
        }
export function useCheckPromoEligibilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckPromoEligibilityQuery, CheckPromoEligibilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckPromoEligibilityQuery, CheckPromoEligibilityQueryVariables>(CheckPromoEligibilityDocument, options);
        }
export type CheckPromoEligibilityQueryHookResult = ReturnType<typeof useCheckPromoEligibilityQuery>;
export type CheckPromoEligibilityLazyQueryHookResult = ReturnType<typeof useCheckPromoEligibilityLazyQuery>;
export type CheckPromoEligibilitySuspenseQueryHookResult = ReturnType<typeof useCheckPromoEligibilitySuspenseQuery>;
export type CheckPromoEligibilityQueryResult = Apollo.QueryResult<CheckPromoEligibilityQuery, CheckPromoEligibilityQueryVariables>;